<template>
  <div class="card activities-card">
    <div class="activities-header">
      <div class="">
        <p class="title">{{ titleDate }}</p>
      </div>
      <div class="add-button-wrapper" v-show="!showNoActivitiesMessage">
        <button class="btn btn-sandpiper btn-icon add-event-btn" type="button" @click="addEventButtonClicked"
                v-hover="onHoverOverEventButton">
          <EventIcon/>
        </button>
        <button class="btn btn-sandpiper btn-icon add-activity-btn ml-2" type="button"
                @click="addActivityButtonClicked" v-hover="onHoverOverActivityButton">
          <AddIcon/>
        </button>
      </div>
    </div>
    <div class="activities-container">
<!--      <ActivitySmall :key="activity.id" v-for="activity in activities" :activity="activity"-->
<!--                     :interactable="true"></ActivitySmall>-->
      <div v-for="(calendarEntry, index) in calendarEntries" :key="index">
        <ActivitySmall :key="calendarEntry.data.id" :activity="calendarEntry.data"
                       :interactable="true" v-if="calendarEntry.type === 'activity'"/>
        <!--                       :hide-title="calendarEntry.data.quest.type === questTypeEnum.impulse"/>-->
        <EventSmall :key="calendarEntry.data.id" :calendar-event="calendarEntry.data"
                    :interactable="true" v-else></EventSmall>
      </div>
    </div>
    <div class="no-activities" v-show="showNoActivitiesMessage">
      <p class="text-muted">Je hebt nog geen activiteiten op deze dag gepland.</p>
      <button class="btn btn-sandpiper btn-icon-text add-activity-btn btn-block" type="button"
              @click="addActivityButtonClicked" v-hover="onHoverOverActivityButton">
        <AddIcon/>
        Activiteit toevoegen
      </button>
      <button class="btn btn-sandpiper btn-icon-text add-event-btn btn-block mt-3" type="button"
              @click="addEventButtonClicked" v-hover="onHoverOverEventButton">
        <EventIcon/>
        Herinnering toevoegen
      </button>
    </div>
    <HoverInfo :show="hoveringOverActivityButton" :content="'Activiteiten inplannen in je agenda'" :offset-y="12"
               :offset-x="12"></HoverInfo>
    <HoverInfo :show="hoveringOverEventButton" :content="'Voeg hier een herinnering toe aan je agenda'" :offset-y="12"
               :offset-x="12"></HoverInfo>

  </div>
</template>

<script>
import ActivitySmall from "@/components/Activities/ActivitySmall";
import DateFormatter from "@/mixins/DateFormatter";
import EventSmall from "@/components/Events/EventSmall";

import AddIcon from "@/assets/image/icons/icon-add.svg?inline";
import EventIcon from "@/assets/image/icons/icon-reminder.svg?inline";
import { QuestTypeEnum } from "sandpiper_api";
import HoverInfo from "@/components/UI/HoverInfo.vue";

export default {
  name: "AgendaActivityList",
  components: {HoverInfo, EventSmall, ActivitySmall, AddIcon, EventIcon},
  mixins: [ DateFormatter ],
  props: {
    currentDate: Date,
    activities: Array,
    events: Array
  },
  emits: [ "add-calendar-event", "add-calendar-activity" ],
  data()
  {
    return {
      questTypeEnum: new QuestTypeEnum(),
      hoveringOverActivityButton: false,
      hoveringOverEventButton: false,
    }
  },
  computed: {
    showNoActivitiesMessage()
    {
      return (this.calendarEntries.length <= 0);
    },
    titleDate()
    {
      return this.formatDateMonthYear(this.currentDate);
    },
    calendarEntries()
    {
      let calendarEntries = [];
      this.activities.forEach(activity =>
      {
        calendarEntries.push({
          type: "activity",
          data: activity
        });
      });

      this.events.forEach(event =>
      {
        calendarEntries.push({
          type: "event",
          data: event
        });
      });

      return calendarEntries;
    }
  },
  methods: {
    addActivityButtonClicked()
    {
      this.$emit("add-calendar-activity");
    },
    addEventButtonClicked()
    {
      this.$emit("add-calendar-event");
    },
    onHoverOverActivityButton(state) {
      this.hoveringOverActivityButton = state;
    },
    onHoverOverEventButton(state) {
      this.hoveringOverEventButton = state;
    }
  },
  created()
  {

  }
}
</script>

<style lang="scss" scoped>
//activities card
.activities-card
{
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 21px;

  .title
  {
    font-size: $title-size;
    font-weight: bold;
    margin-bottom: 0.3rem;
  }

  .subtitle
  {
    font-size: 1rem;
    font-style: italic;
    margin-bottom: 0.3rem;
  }
}

.activities-header
{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}

.activities-container
{
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.no-activities
{
  color: $font-grey;
  font-size: $body-text-size;
}

.btn-add
{
  height: auto;
}

.btn-icon-text
{
  svg
  {
    fill: $font-light;
  }
}

.add-button-wrapper
{
  .btn
  {
    width: 50px;
    line-height: 0;
    padding: 5px;
  }

  svg
  {
    fill: $font-light;
  }
}
</style>